import RedoIcon from '@mui/icons-material/Redo';
import UndoIcon from '@mui/icons-material/Undo';
import { IconButton, styled, Tooltip } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { GlobalItemsWithHistoryHandle, Keyable } from '../filter/types';

const StyledIconButton = styled(IconButton)`
  margin: 0;
  padding: 0;
  pointer-events: auto;
  height: 1.75rem;
  width: 1.75rem;
`;

const StyledDiv = styled('div')`
  display: flex;
  align-items: center;
  margin: 0 0.5rem;
  padding-top: 0.5rem;
`;

export const UndoRedo = <T extends Keyable>({
  itemsHandle,
}: {
  itemsHandle: GlobalItemsWithHistoryHandle<T>;
}) => {
  const { t } = useTranslation();
  const [state, dispatch] = itemsHandle;
  const { undoActive, redoActive } = state;
  return (
    <StyledDiv>
      <Tooltip title={t('common:dashboardSideBar.undo') ?? ''}>
        <div>
          <StyledIconButton
            onClick={() => dispatch({ type: 'undo' })}
            aria-label={t('common:dashboardSideBar.undo')}
            disabled={!undoActive}
          >
            <UndoIcon />
          </StyledIconButton>
        </div>
      </Tooltip>
      <Tooltip title={t('common:dashboardSideBar.redo') ?? ''}>
        <div>
          <StyledIconButton
            onClick={() => dispatch({ type: 'redo' })}
            aria-label={t('common:dashboardSideBar.redo')}
            disabled={!redoActive}
          >
            <RedoIcon />
          </StyledIconButton>
        </div>
      </Tooltip>
    </StyledDiv>
  );
};
